import './index.css'

import React from 'react'
import Icon from 'components/ui/icon'
export type Props = {
  list?: Array<string>
  onSelect: (...args: Array<any>) => any
  selectedItem?: string
  selectCaption: string
}

const SelectedList = (props: Props): null | React.ReactElement<'ul'> => {
  const { list, onSelect, selectedItem, selectCaption } = props
  if (!list) return null
  return (
    <ul className="selected-list">
      {list.map((el, index) => (
        <li key={index} className="selected-list__item">
          {el}
          {selectedItem === el ? (
            <span className="selected-list__item__selected">
              <Icon
                type="check-circle"
                color="#5f63ee"
                width="1em"
                height="1em"
              />
            </span>
          ) : (
            <a
              className="selected-list__item__select"
              onClick={() => onSelect(el)}
            >
              {selectCaption}
            </a>
          )}
        </li>
      ))}
    </ul>
  )
}

export default SelectedList
